


import http from '../lib/http';

export const getTopVouchers = () => http.get('/api/customer/vouchers/top');

export const getShippingVouchers = () => http.get('/api/customer/vouchers/shipping');

export const applyVoucher = async (voucher_id) => {
  return await http.post('/api/customer/vouchers/apply', { voucher_id });
};

export const getAppliedVouchers = () => http.get('/api/customer/vouchers/applied');


